import { render } from "./RefundView.vue?vue&type=template&id=4106fde7&scoped=true"
const script = {}

import "./RefundView.vue?vue&type=style&index=0&id=4106fde7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4106fde7"]])

export default __exports__